export default function addPresetMethod(expressMiddleware) {
  return (ctx, next) => {
    if (ctx.req) {
      expressMiddleware(ctx.req, ctx.res, next);
    }
  };
}